import React from 'react'
import classNames from 'classnames'

export function Base({
  inline,
  component,
  className,
  style,
  children,
  ...props
}) {
  let _component = component
  if (!component && props.href) {
    _component = 'a'
  }
  if (!component && !props.href && inline) {
    _component = 'span'
  }
  if (!component && !props.href && !inline) {
    _component = 'div'
  }
  return React.createElement(
    _component,
    {
      style,
      className,
      ...props,
    },
    children
  )
}

function makeTextComponent(classes = '', component) {
  return ({ children, className = '', ...props }) => {
    return (
      <Base
        className={classNames(classes, className)}
        component={component}
        {...props}
      >
        {children}
      </Base>
    )
  }
}

export const Title = makeTextComponent(
  'shade-05 font-size-largest font-family-system font-weight-bold',
  'h1'
)
export const Subtitle = makeTextComponent(
  'shade-05 font-size-larger font-family-system font-weight-bold',
  'h2'
)
export const SubtitleSmall = makeTextComponent(
  'shade-05 font-size-large font-family-system line-height-larger',
  'h3'
)
export const Corpus = makeTextComponent(
  'shade-10 font-size-large font-family-system line-height-larger font-weight-regular'
)
export const EditorCorpus = makeTextComponent(
  'shade-05 font-size-large font-family-system font-weight-regular'
)
export const Section = makeTextComponent(
  'shade-05 font-size-large font-family-system font-weight-bold'
)
export const Name = makeTextComponent(
  'shade-05 font-size-normal font-family-system font-weight-bold'
)
export const Detail = makeTextComponent(
  'shade-20 font-size-small font-family-system font-weight-regular'
)
export const SmallDetail = makeTextComponent(
  'shade-20 font-size-smaller font-family-system font-weight-regular'
)
export const Callout = makeTextComponent(
  'font-size-smaller font-family-system capitalise font-weight-bold uppercase letter-spacing-small'
)
export const Action = makeTextComponent(
  'pointer shade-20 shade-05-on-hover font-size-normal font-family-system font-weight-medium'
)
export const PrimaryAction = makeTextComponent(
  'pointer primary primary-dark-on-hover font-size-normal font-family-system font-weight-medium'
)
export const ExternalLink = makeTextComponent(
  'pointer shade-20 underline font-size-normal font-family-system font-weight-medium '
)

export default {
  Title,
  Subtitle,
  SubtitleSmall,
  Corpus,
  EditorCorpus,
  Section,
  Name,
  Detail,
  SmallDetail,
  Callout,
  Action,
  PrimaryAction,
  ExternalLink,
}
